export const whyChooseUsItemList = [
  {
    id: 1,
    icon: '/svg/home/why-choose-us/why-choose-us-1.svg',
    description:
      'We help you to automate your recruitment process with the help of AI.'
  },
  {
    id: 2,
    icon: '/svg/home/why-choose-us/why-choose-us-2.svg',
    description:
      'We work with you to create strong and collaborative teams with a growth mindset.'
  },
  {
    id: 3,
    icon: '/svg/home/why-choose-us/why-choose-us-3.svg',
    description:
      'We provide a full cycle of smart solutions to manage and optimize your core HR routines.'
  },
  {
    id: 4,
    icon: '/svg/home/why-choose-us/why-choose-us-4.svg',
    description:
      'We offer methods that help you engage and empower your workforce.'
  },
  {
    id: 5,
    icon: '/svg/home/why-choose-us/why-choose-us-5.svg',
    description:
      'We help generate valuable insights across your business to let leaders make accurate decision swiftly.'
  }
];
